import { useQueryClient } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { removePreset } from '@api/kpi';

import { IEditPresetNameDTO } from '@interfaces/kpi/dto/kpiDTO';

import { ESnackbarTypes } from '@enums/common';

import { DELETE_PRESET, PRESET_OPTIONS } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

export const useMutateRemovePreset = () => {
	const dispatch = useAppDispatch();
	const queryClient = useQueryClient();

	const {
		mutate: deletePreset,
		isLoading: isLoadingDeletePreset,
	} = useMutation<{ id: string }>({
		mutationKey: [DELETE_PRESET],
		mutationFn: async (data: IEditPresetNameDTO) => {
			await removePreset({ id: data.id });

			dispatch(setSnackbar({
				message: responseMessages.deleteKpiPreset(data.name),
				type: ESnackbarTypes.success,
			}));
		},
		onSuccess: () => {
			return queryClient.invalidateQueries([PRESET_OPTIONS]);
		},
	});

	return {
		deletePreset,
		isLoadingDeletePreset,
	};
};
